import {Field, reduxForm} from "redux-form";
import React from 'react';
import {email, phoneNumber, required} from "../validators";
import {withStyles} from '@material-ui/core/styles';
import WrapWithLoader from "./WrapWithLoader";


const renderTextInput = (field) => {
  return (
    <div className="form-group">
      <label>{field.label}</label>
      <input {...field.input} className="form-control" type={field.type}/>
      {field.meta.touched && field.meta.error &&
      <small className="error form-text text-muted">{field.meta.error}</small>}
    </div>
  );
};


function ProSignUpPart1Form(props) {
  const {classes, handleSubmit, valid, submitting} = props;

  return (
    <form id="part1-create-account" onSubmit={handleSubmit}>
      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-6">
          <h2>Create Account</h2>
        </div>
      </div>
      {/* Account Info */}
      <div id="account-info" className="form-section">
        <div className="row justify-content-center header">
          <div className="col-md-12 col-lg-6">
            <h4>Contact Information</h4>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <Field
              name="name"
              label={"Name"}
              component={renderTextInput}
              validate={[required]}
              type='text'/>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <Field
              name="email"
              label={"Email"}
              component={renderTextInput}
              validate={[required, email]}
              type='email'/>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="InputPhoneNumber">Phone Number</label>
              <div className="form-inline">
                <Field name={`countryCode`} component="select"
                       className="custom-select countryCode">
                  <option value="+65">+65</option>
                  <option value="+60">+60</option>
                </Field>
                <Field
                  component='input'
                  type={'tel'}
                  name="phoneNumber"
                  className="form-control phoneNumber"
                  validate={[required, phoneNumber]}/>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Work Eligibility */}
      <div id="work-eligibility" className="form-section">
        <div className="row justify-content-center header">
          <div className="col-md-12 col-lg-6">
            <h4>Work Eligibility</h4>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <Field component="select" className="custom-select form-control" name="workEligibility"
                   validate={[required]}
                   id="inputWorkEligibility">
              <option disabled value="">Please select one</option>
              <option>Citizen or Permanent Resident</option>
              <option>Employment Pass</option>
              <option>Student Pass</option>
              {(window.location.hostname.indexOf('.my') !== -1) ? (
                <React.Fragment>
                  <option>Temporary Employment Pass</option>
                  <option>Professional Visit Pass</option>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <option>S Pass</option>
                  <option>Work Permit</option>
                </React.Fragment>
              )}
              <option>Other</option>
            </Field>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <small id="inputWorkEligibilityHelpBlock" className="form-text text-muted">
              Your answer is confidential.
            </small>
          </div>
        </div>
      </div>
      {/* Invited by Friend */}
      <div id="invited-by-friend" className="form-section">
        <div className="row justify-content-center header">
          <div className="col-md-12 col-lg-6">
            <h4>Invited by a Friend</h4>
            <p className="text-muted">If you were invited by a friend, enter their phone number to both get a
              10% wage increase bonus on the next shift.</p>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-6">
            <div className="form-group">
              <label htmlFor="inputReferralPhoneNumber">Friend's Phone Number (optional)</label>
              <div className="form-inline">
                <Field component="select" className="custom-select countryCode" name="referralCountryCode"
                       id="inputReferralCountryCode">
                  <option value="+65">+65</option>
                  <option value="+60">+60</option>
                </Field>
                <Field component="input" type="tel" name="referralPhoneNumber" id="inputReferralPhoneNumber"
                       validate={[phoneNumber]}
                       className="form-control phoneNumber"/>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Continue */}
      <div className="row justify-content-center">
        <div className="col-md-12 col-lg-6">
          <WrapWithLoader loading={submitting}>
            <button id="submitContinue"
                    className="btn btn-primary btn-xlg btn-block btn-pointer"
                    disabled={submitting || !valid}
                    type="submit">
              Continue
            </button>
          </WrapWithLoader>
        </div>
      </div>
    </form>
  )
}

const styles = (theme) => ({
  wrapper: {
    position: 'relative',
  },
  buttonProgress: {
    color: theme.palette.primary.main,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
});

export default reduxForm({
  form: 'proSignUpPart1Form',
  initialValues: {
    countryCode: '+65',
    referralCountryCode: '+65',
  },
})(withStyles(styles)(ProSignUpPart1Form));


// WEBPACK FOOTER //
// ./src/parts/ProSignUpPart1Form.js